import {
    AfterContentInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    HostBinding,
    OnChanges,
    OnDestroy,
} from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

import { SpsTableL3PinnedCols } from "./l3-pinned-cols";

@Component({
    selector: "sps-table",
    templateUrl: "./sps-table.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpsTableComponent extends SpsTableL3PinnedCols implements AfterContentInit, OnChanges, OnDestroy {
    static readonly displayName = "sps-table";
    static readonly props = {
        ...SpsTableL3PinnedCols.props,
    };

    @HostBinding("attr.role") readonly _roleAttr = "table";
    @HostBinding("class.sps-table-container") readonly _spsTableContainerClass = true;

    constructor(
        changeDetector: ChangeDetectorRef,
        domSanitizer: DomSanitizer,
    ) {
        super(changeDetector, domSanitizer);
    }
}
